export default __webpack_public_path__ + "static/media/add-plus-icon.e910b0d7.svg";